export default {
  'header.mainPage': {
    fi: 'Referenssipankki',
    gb: 'Referencebank'
  },
  'header.mainTable': {
    fi: 'Referenssit',
    gb: 'References'
  },

  locale: { fi: 'Kieliversio', gb: 'Language' },

  username: {
    fi: 'Käyttäjätunnus',
    gb: 'Username'
  },
  password: { fi: 'Salasana', gb: 'Password' },
  name: { fi: 'Nimi', gb: 'Name' },
  phone: { fi: 'Puhelinnumero', gb: 'Phonenumber'},
  email: { fi: 'Sähköposti', gb: 'Email'},
  job: { fi: 'Tehtävä', gb: 'Job'},
  header: { fi: 'Otsikko', gb: 'Subject'},
  type: { fi: 'tyyppi', gb: 'Type'},
  firstName: { fi: 'Etunimi', gb: 'First Name'},
  lastName: { fi: 'Sukunimi', gb: 'Last Name'},
  company: { fi: 'Yhtiö', gb: 'Organisation'},
  jobTitle: { fi: 'Työ-nimike', gb: 'Job Title'},

  templateRightsLevel: { fi: 'Käyttäjäluokka', gb: 'User Role'},
  authenticationKey: { fi: 'Tunnistautumisavain', gb: 'Authentication Key' },
  login: { fi: 'Kirjaudu', gb: 'Sign In'},
  register: { fi: "Rekisteröidy", gb: 'Sign Up'},
  actions: { fi: 'Toiminnot', gb: 'Actions'},
  search: { fi: 'Hae', gb: 'Search'},
  edit: { fi: 'Muokkaa', gb: 'Edit'},
  delete: { fi: 'Poista', gb: 'Delete'},
  cancel: { fi: 'Peruuta', gb: 'Cancel'},
  save: { fi: 'Tallenna', gb: 'Save'},
  add: { fi: 'Lisää', gb: 'Save'},
  add_row: { fi: 'Lisää Rivi', gb: 'Add Row'},
  remove_row: { fi: 'Poista Rivi', gb: 'Delete Row'},
  'case.image.placeholder': { fi: 'Kuvausteksti', gb: 'Image caption' },
  'template.name': { fi: 'Nimi', gb: 'Name' },
  'template.html': 'HTML',
  'dialog.confirmation': { fi: 'Oletko varma?', gb: 'Are you sure?'},
  'nav.cases': { fi: 'Referenssit', gb: 'References'},
  'nav.addNewCase': { fi: 'Lisää referenssi', gb: 'Add reference'},
  'nav.addNewUser': { fi: 'Lisää käyttäjä', gb: 'Add user'},
  'nav.addNewTemplate': { fi: 'Lisää Template', gb: 'Add template'},
  'nav.users': { fi: 'Käyttäjät', gb: 'Users'},
  'nav.logout': { fi: 'Kirjaudu ulos', gb: 'Sign out'},
  'nav.admin': { fi: 'Ylläpitäjä', gb: 'Admin'},
  'nav.consumer': { fi: 'Asiakas', gb: 'Client'},
  'nav.templates': { fi: 'Templates', gb: 'Templates'},
  'action.create_success': { fi: 'Lisääminen onnistui', gb: 'Added succesfully'},
  'action.create_failed': { fi: 'Lisääminen epäonnistui', gb: 'Adding failed'},
  'action.update_success': { fi: 'Tallennus onnistui', gb: 'Saved succesfully'},
  'action.update_failed': { fi: 'Tallennus epäonnistui', gb: 'Saving failed'},
  'action.remove_success': { fi: 'Poistaminen onnistui', gb: 'Removal failed'},
  'action.remove_failed': { fi: 'Poistaminen epäonnistui', gb: 'Removed succesfully'},
  'action.export_pdf': { fi: 'Lataa PDF', gb: 'Export as PDF'},
  'privileges.admin': { fi: 'Ylläpitäjä', gb: 'Admin'},
  'privileges.manager': { fi: 'Manageri', gb: 'Manager'},
  'privileges.user': { fi: 'Käyttäjä', gb: 'User'},
  'privileges.no_access': { fi: 'Ei pääsyä sivustolle', gb: 'Access denied'}
};



// WEBPACK FOOTER //
// ./src/texts/translations.js